import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';

const CancelOffersHeaderLinks = props => {
  const { onSave, disabledSave } = props;
  const [t] = useTranslation();
  return (
    <IconButton
      type='save'
      fontSize='medium'
      color='transparent'
      tooltip={t('CancelOffers.SaveChanges')}
      onClick={onSave}
      disabled={disabledSave}
    />
  );
};

CancelOffersHeaderLinks.propTypes = {
  onSave: PropTypes.func.isRequired,
  disabledSave: PropTypes.bool.isRequired
};

export default CancelOffersHeaderLinks;
